module.exports = __webpack_public_path__ + "img/news-1.4b460e52.jpg";